import { z } from "zod";

import { isoDate, nullableIsoDate } from "./iso-date-schema";
import { placeItemSchema } from "./place-schema";
import { userItemSchema } from "./user-item-schema";

// Enum mimics from your schema — adjust as needed
export const priorityEnum = z.enum(["NORMAL", "HIGH"]);
export const serviceTypeEnum = z.enum(["JOB", "RECURRING_JOB", "PROJECT"]); // Example

export const orderStatusItemSchema = z.object({
  id: z.string().length(24),
  shortId: z.string().nullable(),
  status: z.string(),
  statusKey: z.string(),
  customerLabel: z.string(),
  customerLabelKey: z.string(),
  isDeleted: z.boolean(),
  order: z.number().int(),
  createdAt: isoDate,
  updatedAt: isoDate,
});

export const orderDetailSchema = z.object({
  id: z.string().length(24),
  subject: z.string(),
  placeId: z.string(),
  userCreated: z.string(),
  requesterId: z.string(),
  assigneeId: z.string().nullable(),
  statusId: z.string(),
  membershipId: z.string().nullable(),
  createdAt: isoDate,
  updatedAt: isoDate,
  description: z.string().nullable(),
  cancelledAt: nullableIsoDate,
  completedAt: nullableIsoDate,
  dueDateAt: nullableIsoDate,
  managerId: z.string().nullable(),
  serviceType: serviceTypeEnum.nullable(),
  serviceValue: z.number().nullable(),
  orderNumber: z.string(),
  uuid: z.string().uuid(),
  priority: priorityEnum,
  serviceStatus: orderStatusItemSchema.nullish(),
  place: placeItemSchema.nullish(),
  requester: userItemSchema.nullish(),
});
